import React from "react";
import "./footer.scss";
import {
  facebookIconWhite,
  instagramWhite,
  linkedInWhite,
  tiktokWhite,
  upArrowGreen,
  youtubeWhite,
} from "../../source";
import { Link } from "react-router-dom";
import {
  aboutUsURL,
  contactUsURL,
  faqsURL,
  interviewsURL,
  privacypolicyURL,
  reflectionsURL,
  termsandconditionURL,
} from "../../helpers/constants";
import { useWindowSize } from "react-use";

const Footer = () => {
  const { width } = useWindowSize();
  const currentYear = new Date();

  const scrollHandler = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="footer">
        <div className="row footer_row">
          <div className="col-md-6 footer_col">
            <div className="left_box">
              <div className="head_wrapper">
                <h2 className="footer_title">
                  Breaking down barriers, one perspective at a time
                </h2>
                {width > 767 ? null : (
                  <div className="up_arrow_wrapper" onClick={scrollHandler}>
                    <img
                      src={upArrowGreen}
                      alt="up arrow"
                      className="up_arrow"
                    />
                  </div>
                )}
              </div>
              {width > 767 && (
                <div className="social_media">
                  {/* <a
                    href="https://www.linkedin.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="social_link"
                  >
                    <img
                      src={linkedInWhite}
                      alt="linkedIn"
                      className="social_icon"
                    />
                  </a> */}
                  <a
                    href="https://www.instagram.com/pathwaysandperspectives/"
                    target="_blank"
                    rel="noreferrer"
                    className="social_link"
                  >
                    <img
                      src={instagramWhite}
                      alt="instagram"
                      className="social_icon"
                    />
                  </a>
                  {/* <a
                    href="#"
                    // target="_blank"
                    // rel="noreferrer"
                    className="social_link"
                    onClick={(e)=>e.preventDefault()}
                  >
                    <img
                      src={facebookIconWhite}
                      alt="facebook"
                      className="fb_icon social_icon"
                    />
                  </a> */}
                  <a
                    href="https://www.youtube.com/@pathwaysandperspectives?reload=9&si=pnT90jYiMA6fdUVq"
                    target="_blank"
                    rel="noreferrer"
                    className="social_link"
                  >
                    <img
                      src={youtubeWhite}
                      alt="youtube"
                      className="social_icon"
                    />
                  </a>
                  {/* <a
                    href="#"
                    // target="_blank"
                    // rel="noreferrer"
                    className="social_link"
                    onClick={(e)=>e.preventDefault()}
                  >
                    <img
                      src={tiktokWhite}
                      alt="tiktok"
                      className="social_icon"
                    />
                  </a> */}
                  <div className="contact_head text_start_ft">
                    Sattvic Retreats Limited.
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-md-3 col-6 footer_col">
            <div className="middle_box">
              <div className="link_wrapper">
                <p className="links">
                  <Link to={aboutUsURL}>About</Link>
                </p>
                <p className="links">
                  <Link to={interviewsURL}>Interviews</Link>
                </p>
                {/* <p className="links">
                  <Link to={aboutUsURL}>Events</Link>
                </p>
                <p className="links">
                  <Link to={aboutUsURL}>Consultations</Link>
                </p> */}
                {/* <p className="links">
                  <Link to={aboutUsURL}>Merchandise</Link>
                </p> */}
                <p className="links">
                  <Link to={reflectionsURL}>Reflections</Link>
                </p>
                <p className="links">
                  <Link to={contactUsURL}>Contact Us</Link>
                </p>
                {/* <p className="links">
                  <Link to={aboutUsURL}>Press</Link>
                </p> */}
              </div>
            </div>
          </div>

          <div className="col-md-3 col-6 footer_col">
            <div className="right_box">
              <div className="link_wrapper">
                <p className="links">
                  <Link to={privacypolicyURL}>Privacy Policy</Link>
                </p>
                <p className="links">
                  <Link to={termsandconditionURL}>Terms of Use</Link>
                </p>
                <p className="links">
                  <Link to={faqsURL}>FAQs</Link>
                </p>
              </div>

              {width > 767 && (
                <div className="contact_details">
                  <div className="contacts">
                    <p className="contact_head">EMAIL</p>
                    <a
                      href="mailto:seek@pathwaysperspectives.com"
                      className="contact_link"
                    >
                      seek@pathwaysperspectives.com
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>

          {width <= 767 && (
            <div className="col-12 footer_col">
              <div className="mob_social_contact">
                <div className="contact_details">
                  <div className="contacts">
                    <p className="contact_head">EMAIL</p>
                    <a
                      href="mailto:seek@pathwaysperspectives.com"
                      className="contact_link"
                    >
                      seek@pathwaysperspectives.com
                    </a>
                  </div>
                </div>

                <div className="social_media">
                  {/* <a
                    href="https://www.linkedin.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="social_link"
                  >
                    <img
                      src={linkedInWhite}
                      alt="linkedIn"
                      className="social_icon"
                    />
                  </a> */}
                  <a
                    href="https://www.instagram.com/pathwaysandperspectives/"
                    target="_blank"
                    rel="noreferrer"
                    className="social_link"
                  >
                    <img
                      src={instagramWhite}
                      alt="instagram"
                      className="social_icon"
                    />
                  </a>
                  {/* <a
                    href="#"
                    // target="_blank"
                    // rel="noreferrer"
                    className="social_link"
                    onClick={(e)=>e.preventDefault()}
                  >
                    <img
                      src={facebookIconWhite}
                      alt="facebook"
                      className="fb_icon social_icon"
                    />
                  </a> */}
                  <a
                    href="https://www.youtube.com/@pathwaysandperspectives?reload=9&si=pnT90jYiMA6fdUVq"
                    target="_blank"
                    rel="noreferrer"
                    className="social_link"
                    style={{
                      marginRight: "0px",
                    }}
                  >
                    <img
                      src={youtubeWhite}
                      alt="youtube"
                      className="social_icon"
                    />
                  </a>
                  {/* <a
                    href="#"
                    // target="_blank"
                    // rel="noreferrer"
                    className="social_link"
                    onClick={(e)=>e.preventDefault()}
                  >
                    <img
                      src={tiktokWhite}
                      alt="tiktok"
                      className="social_icon"
                    />
                  </a> */}
                  <div className="contact_head text_start_ft">
                    Sattvic Retreats Limited.
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="copyright_wrapper">
          <p className="copy_text">
            Pathways & Perspectives © All Rights Reserved -{" "}
            {currentYear.getFullYear()}
          </p>
          <p className="copy_text">
            <a
              href="https://www.togglehead.in/"
              target="_blank"
              rel="noreferrer"
            >
              Crafted by Togglehead
            </a>
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
